import {cellErrorCheck} from './cellErrorCheck.js';

const AUTOCAD_LINE_CHARACTER_LIMIT = 80;
const REVIT_LINE_CHARACTER_LIMIT = 4096;

const AUTOCAD_DASH_SPACE_LIMIT = 6;

const checkForErrors = (pattern) => {

  for(var i in pattern.rows){
    pattern.rows[i].errors = [];

    var offset_error = cellErrorCheck(Math.abs(pattern.rows[i].cells[4]), pattern.format, pattern.type, pattern.units);
    if(offset_error){
      if(offset_error.type === 'TOO_SMALL'){
        pattern.rows[i].errors.push("Offset should be larger than " + offset_error.limit.toLocaleString() + (pattern.units == "INCH" ? "in" : "mm") + " for Revit " + pattern.type.toLowerCase() + " patterns.");
      }
      if(offset_error.type === 'TOO_BIG'){
        pattern.rows[i].errors.push("Offset should be smaller than " + offset_error.limit.toLocaleString() + (pattern.units == "INCH" ? "in" : "mm") + " for Revit " + pattern.type.toLowerCase() + " patterns.");
      }
    }

    var sum = 0;
    var cellsWithValues = 0;
    for(var j = 5; j < pattern.rows[i].cells.length; j++){
      sum += Math.abs(pattern.rows[i].cells[j]);
      if(pattern.rows[i].cells[j] !== ""){
        cellsWithValues++;
      }
    }
    
    var dash_space_error = cellErrorCheck(sum, pattern.format, pattern.type, pattern.units);
    if(dash_space_error){
      if(dash_space_error.type === 'TOO_SMALL' && sum !== 0){
        pattern.rows[i].errors.push("The absolute sum of all dash & space values should be larger than " + dash_space_error.limit.toLocaleString() + (pattern.units == "INCH" ? "in" : "mm") + " for Revit " + pattern.type.toLowerCase() + " patterns.");
      }
      if(dash_space_error.type === 'TOO_BIG'){
        pattern.rows[i].errors.push("The absolute sum of all dash & space values should be smaller than " + dash_space_error.limit.toLocaleString() + (pattern.units == "INCH" ? "in" : "mm") + " for Revit " + pattern.type.toLowerCase() + " patterns.");
      }
    }

    if(pattern.format === 'AUTOCAD'){
      if(cellsWithValues > AUTOCAD_DASH_SPACE_LIMIT){
        pattern.rows[i].errors.push("AutoCAD patterns cannot contain more that 6 total dash & space components per line.");
      }
    }

    for(var j = 5; j < pattern.rows[i].cells.length; j++){

      if((j - 5) % 2 == 1 && pattern.rows[i].cells[j] > 0){
        pattern.rows[i].errors.push("Space values must be negative.");
      }
      if((j - 5) % 2 == 0 && pattern.rows[i].cells[j] < 0){
        pattern.rows[i].errors.push("Dash values must be positive.");
      }
    }

    if(cellsWithValues % 2 == 1 > cellsWithValues >= 0){
      pattern.rows[i].errors.push("Dash and space values must come in pairs.");
    }
  }

  // Line length check
  var lines = pattern.text.split('\n');
  var index = 0;
  for(var i in lines){
    if(lines[i].indexOf(';angle') === 0){
      // lines[i] = {headerRow: true}
    } else if(lines[i][0] === '*' || lines[i][0] === ';' || lines[i][0] === ' ' || lines[i].trim() === ''){
      // lines[i] = {skip: true}
    } else {
      
      if(pattern.format === 'AUTOCAD' && lines[i].length > AUTOCAD_LINE_CHARACTER_LIMIT){
        var e = "Line too long. AutoCAD patterns cannot have lines longer than " + AUTOCAD_LINE_CHARACTER_LIMIT + " characters";
        if(pattern.mode !== 'raster'){
          e += " Decrease decimal precision to fix this issue.";
        }
        pattern.rows[index].errors.push(e);
      }

      if(pattern.format === 'REVIT' && lines[i].length > REVIT_LINE_CHARACTER_LIMIT){
        var e = "Line too long. Revit patterns cannot have lines longer than " + REVIT_LINE_CHARACTER_LIMIT + " characters";
        if(pattern.mode !== 'raster'){
          e += " Decrease decimal precision to fix this issue.";
        }
        pattern.rows[index].errors.push(e);
      }
      index++;
    }
  }


  return pattern;
}

export default checkForErrors;


// WEBPACK FOOTER //
// ./src/pattern_utilities/checkForErrors.js